import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { getAll, registration, edit, deleteUser } from "../http/userApi";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Dialog from "@mui/material/Dialog";
import { useNavigate } from "react-router-dom";
import { LOGIN_ROUTE } from "../utils/constants";
import { observer } from "mobx-react-lite";
import { Context } from "../index";
import {ROLES} from "../utils/constants";

const Users = observer(() => {
  const [parse, setParse] = React.useState([]);
  const [columns, setColumns] = React.useState(null);
  const [email, setEmail] = React.useState("");
  const [name, setName] = React.useState("");
  const [login, setLogin] = React.useState("");
  const [showForm, setShowForm] = React.useState(false);
  const [editId, setEditId] = React.useState(0);
  const [password, setPassword] = React.useState("");
  const [role, setRole] = React.useState(1);
  const navigate = useNavigate();
  const { user } = React.useContext(Context);

  const getData = async () => {
    try {
      const parsed = await getAll();
      setParse([...parsed]);
      const rows = Object.keys(parsed[0]);
      const iter = [];
      for (let key in rows) {
        const item = rows[key];
        console.log(item);
        let width = 200;
        if(item === "id"){
          width = 30;
        } else if(item === "email"){
          width = 200;
        } else if(item === "login"){
          width = 200;
        } else if(item === "role"){
          width = 80;
        } else if(item === "createdAt"){
          width = 120;
        } else if(item === "updatedAt"){
          width = 120;
        }
        iter.push({
          field: item,
          headerName: item,
          width: width,
          editable: false,
          description: item,
          sortable: true,
        });
      }
      setColumns(iter);
    } catch (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        user.setIsAuth(false);
        return navigate(LOGIN_ROUTE);
      }
    }
  };

  const onDelete = async ()=>{
    console.log(editId);
    if(window.confirm("Точно удалить пользователя?")) {
      await deleteUser(editId);
      await getData();
      setRole(1);
      setPassword("");
      setEmail("");
      setLogin("");
      setName("");
      setEditId(0);
    }
  }

  const rowClick = ({row})=>{
    console.log(row);
    const {id, role, email, name, login} = row;
    let roleNum = 1;
    for (const num in ROLES) {
      if(ROLES[num] === role){
        roleNum = num;
      }
    }
    setPassword("");
    setRole(roleNum);
    setEmail(email);
    setLogin(login);
    setName(name);
    setEditId(id);
    setShowForm(true);
  }

  React.useEffect(() => {
    setEmail("");
    setLogin("");
    setPassword("");
    setName("");
    getData();
  }, []);

  const onAddUser = async () => {
    try {
      const response = await registration(email, password, name, ROLES[role], login);
      console.log(response);
      await getData();
      setRole(1);
      setPassword("");
      setEmail("");
      setLogin("");
      setName("");
    } catch (error) {
      console.log(error);
    }
  };

  const onEditUser = async () => {
    try {
      const response = await edit(editId, email, password, name, ROLES[role]);
      console.log(response);
      await getData();
      setRole(1);
      setPassword("");
      setEmail("");
      setLogin("");
      setName("");
      setEditId(0);
    } catch (error) {
      console.log(error);
    }
  };

  const onSubmit = async () => {
    console.log(editId);
    if(editId){
      await onEditUser();
      setShowForm(false);
    } else {
      await onAddUser();
      setShowForm(false);
    }
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <Box
          display="flex"
          alignItems="center"
          flexDirection="row"
          justifyContent="flex-end"
          width={'100%'}
          p={2}
      >
        <Button
            color="secondary"
            variant="outlined"
            onClick={()=>{
          setShowForm(true);
          setPassword("");
          setEmail("");
          setLogin("");
          setRole(1);
        }}>Создать пользователя</Button>
      </Box>
      <Dialog
          open={showForm}
          onClose={()=>{setShowForm(false); setEditId(0);}}
          width={800}
          my={4}
          gap={4}
          p={2}
          sx={{ border: "2px solid grey" }}
      >
        <Box
          p={2}
        >
          <Typography variant="h4" gutterBottom>
            {editId ? "Редактирование пользователя" : "Создание пользователя"}
          </Typography>
        </Box>
        <Box
            width={"100%"}
            p={2}
            display="flex"
            alignItems="center"
            gap={4}
            justifyContent="space-between"
        >
          <TextField
              className="login__page__item"
              label="Name"
              variant="outlined"
              color="secondary"
              value={name}
              sx="flex: 1 1 100%"
              onChange={(e) => setName(e.target.value)}
          />
          <TextField
              className="login__page__item"
              label="Email"
              variant="outlined"
              color="secondary"
              value={email}
              sx="flex: 1 1 100%"
              onChange={(e) => setEmail(e.target.value)}
          />
        </Box>
        <Box
            width={"100%"}
            p={2}
            display="flex"
            alignItems="center"
            gap={4}
            justifyContent="space-between"
        >
          <TextField
              className="login__page__item"
              label="Login"
              variant="outlined"
              color="secondary"
              value={login}
              sx="flex: 1 1 100%"
              onChange={(e) => setLogin(e.target.value)}
          />
          <TextField
            label="Пароль"
            variant="outlined"
            color="secondary"
            type="password"
            value={password}
            sx="flex: 1 1 100%"
            onChange={(e) => setPassword(e.target.value)}
          />
          <Select
              label={"Роль"}
              value={role}
              onChange={(e)=>setRole(e.target.value)}
              sx="flex: 1 1 100%"
          >
            {ROLES.map((item, key) => <MenuItem value={key}>{item}</MenuItem>)}
          </Select>
        </Box>
        <Box
            p={2}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gap={4}
        >
          <Button
              variant="outlined"
              color="secondary"
              onClick={()=>{
                setEmail("");
                setLogin("");
                setRole(1);
                setPassword("");
                setEditId(0);
                setShowForm(false);
              }}
          >
            Отмена
          </Button>
          {editId ?
            <Button
                variant="contained"
                color="error"
                onClick={onDelete}
            >
              Удалить
            </Button>: null
          }
          <Button
              variant="contained"
              color="secondary"
              onClick={onSubmit}
          >
            {editId ? "Обновить пользователя" : "Добавить пользователя"}

          </Button>
        </Box>
      </Dialog>
      {parse && columns && (
        <Box sx={{ height: "100%", width: "100%" }}>
          <DataGrid
            rows={parse}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 100,
                },
              },
            }}
            pageSizeOptions={[10, 20, 50, 100]}
            disableRowSelectionOnClick
            checkboxSelection
            onRowClick={rowClick}
          />
        </Box>
      )}
    </div>
  );
});

export default Users;
